module.exports = __webpack_public_path__ + "static/media/gcect.49d366c2.jpg";